import * as React from "react";
import {imageBaseUrl} from "config";
import Button from "../button";
import "./index.scss";
import {CC_EMAIL_ID, COLOR} from "utils/variables";
import {MessageType} from "utils/variables";


interface IFlashCardProps {
  messageType: MessageType;
  heading: string;
  iconUrl?: string;
  description?: string;
  supportEmail?: boolean;
  supportText?: string;
  buttonText?: string;
  buttonWidth?: string;
  buttonHeight?: number;
  buttonBgColor?: string;
  onButtonClick?: () => void;
  supportEmailText?: string;
}

const Flashcard = ({supportEmailText = CC_EMAIL_ID, ...props}: IFlashCardProps) => {
  return (
    <div className="flashcard-container">
      <div className="flashcard">
        <img
          className="top-icon"
          src={props.iconUrl ? props.iconUrl : `${imageBaseUrl}/img/${props.messageType === MessageType.SUCCESS ? "success-icon.gif": "error-gif.gif"}`}
          alt="status"
        />
          <h1 className={`flashcard-heading ${props.messageType === MessageType.SUCCESS ? MessageType.SUCCESS: MessageType.ERROR}`}>
            {props.heading}
          </h1>
        {props.description &&
          <p className="error-description">
           {props.description}
          </p>
        }
        {
          props.messageType !== MessageType.SUCCESS && props.supportEmail &&
          <p className="support-message">
            {props.supportText}
            <a href={`mailto:${supportEmailText}`}>
              {supportEmailText}
              </a>
          </p>
        }
        {!!props.onButtonClick && !!props.buttonText && <div className="flash-button-container">
          <Button 
            buttonText={props.buttonText} 
            onClick={props.onButtonClick}
            height={props.buttonHeight}
            width={props.buttonWidth}
            bgColor={props.buttonBgColor}
          />
        </div>}
      </div>
    </div>
  );
};

Flashcard.defaultProps = {
  buttonHeight: 25,
  buttonWidth: "200px",
  supportText: "Please try again or contact support",
  buttonBgColor: COLOR.PRIMARY,
};

export default Flashcard;